import {Component, OnInit} from '@angular/core';
import {saveAs} from "file-saver";
import {ActivatedRoute, Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthService} from '../../../services/auth';
import {Inspection} from '../../../classes/inspection';
import {InspectionService} from '../../../services/inspection';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GeneralModalComponent} from "../../../modals/general/general-modal/general-modal.component";
import {User} from "../../../classes/user";
import {mergeMap, tap} from "rxjs/operators";
import {InspectionOrderService} from "../../../services/inspectionOrder";
import {InspectionOrder} from "../../../classes/inspectionOrder";
import {DocumentService} from "../../../services/document";
import {Document} from "../../../classes/document";

@Component({
    selector: 'app-inspection-detail',
    templateUrl: './inspection-detail.component.html',
    styleUrls: ['./inspection-detail.component.css']
})
export class InspectionDetailComponent implements OnInit {
    action: string = '';
    user!: User;
    inspection!: Inspection;
    inspectionOrders: Array<InspectionOrder> = [];
    inspectionDocuments: Array<Document> = [];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private modalService: NgbModal,
                private inspectionService: InspectionService,
                private inspectionOrderService: InspectionOrderService,
                private documentService: DocumentService) {
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.action = this.router.url.split('/')[1];
            this.inspectionService.getByID(params.get('id'))
                .pipe(
                    tap((inspection: any) => {
                        this.inspection = inspection;
                    }),
                    mergeMap(() => this.inspectionOrderService.getByIDInspection(params.get('id'))),
                )
                .subscribe({
                    next: (inspectionOrders: any) => {
                        this.inspectionOrders = inspectionOrders;
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
            this.documentService.getByIDInspection(params.get('id'))
                .subscribe({
                    next: (documents: any) => {
                        this.inspectionDocuments = documents;
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
        this.user = this.authService.getUser();
    }

    openDeleteInspectionModal() {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Rimozione <strong>Ispezione</strong>';
        modalRef.componentInstance.text = 'Confermi la rimozione dell\'ispezione della PA "' + this.inspection.pa.name + '"?';
        modalRef.result.then(() => {
            if (this.inspection.id_inspection) {
                this.inspectionService.delete(this.inspection.id_inspection)
                    .subscribe({
                        next: () => {
                            this.router.navigate(['/inspection']);
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }

    openDeleteInspectionOrderModal(inspectionOrder: InspectionOrder) {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Rimozione <strong>Ordinativo</strong>';
        modalRef.componentInstance.text = 'Confermi la rimozione dell\'ordinativo numero "' + inspectionOrder.number + '"?';
        modalRef.result.then(() => {
            if (inspectionOrder.id_inspection_order) {
                this.inspectionOrderService.delete(inspectionOrder.id_inspection_order)
                    .subscribe({
                        next: () => {
                            this.inspectionOrders = this.inspectionOrders.filter((currInspectionOrder: InspectionOrder) =>
                                currInspectionOrder.id_inspection_order !== inspectionOrder.id_inspection_order);
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }

    downloadInspectionDocument(inspectionDocument: Document) {
        this.documentService.download(inspectionDocument.fk_id_inspection.toString(), inspectionDocument.name)
            .subscribe({
                next: (blobFile) => {
                    saveAs(blobFile, inspectionDocument.name);
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    openDeleteInspectionDocumentModal(inspectionDocument: Document) {
        const modalRef = this.modalService.open(GeneralModalComponent);
        modalRef.componentInstance.title = 'Rimozione <strong>Documento</strong>';
        modalRef.componentInstance.text = 'Confermi la rimozione del documento con titolo "' + inspectionDocument.name + '"?';
        modalRef.result.then(() => {
            if (inspectionDocument.id_document) {
                this.documentService.delete(inspectionDocument.id_document)
                    .subscribe({
                        next: () => {
                            this.inspectionDocuments = this.inspectionDocuments.filter((currInspectionDocument: Document) =>
                                currInspectionDocument.id_document !== inspectionDocument.id_document);
                        },
                        error: (err: HttpErrorResponse) => {
                            console.log(err);
                        }
                    });
            }
        });
    }
}
